import React from 'react';
import cx from 'classnames';
import { Grid, Row, Col, Image, Clearfix, Card, FormGroup, InputGroup, FormControl, Button as SearchButton } from 'react-bootstrap';
import PlaceholderEmptyMessage from 'src/legacy/components/PlaceholderEmptyMessage';
import RolodexEmptyMessageSvgIcon from 'src/legacy/images/rolodexEmptyMessage.svg';
import InfiniteScroll from 'react-infinite-scroller';
import styles from './styles.module.scss';
import isEqual from 'is-equal';
import { localizedStrings } from 'src/localization/index.jsx';
import Button from 'src/components/button';
import Truncate from 'src/components/truncate';
import _ from "lodash";

class AddUsersView extends React.Component {
  constructor(props){
    super(props);

    this.state = {
      query: ""
    }

    this._handleSearchQueryChange = this._handleSearchQueryChange.bind(this);
    this._handleCancelClick = this._handleCancelClick.bind(this);
    this._toggleSelection = this._toggleSelection.bind(this);
    this._handleCreateClick = this._handleCreateClick.bind(this);
    this._handleSearch = this._handleSearch.bind(this);
    this.loadMoreUsers = this.loadMoreUsers.bind(this);

    this.localizedCommons = localizedStrings.commons;
    this.localizedCommonLoading = this.localizedCommons.loading;
    this.localizedCommonActions = this.localizedCommons.actions;
    this.localizedSettings = localizedStrings.pages.settings;
    this.localizedUserManagement = this.localizedSettings.account.user_management;
    this.localizedNewGroup = this.localizedUserManagement.create_new_group;
  }

  componentDidMount() {
    this.props.fetchUsers({query: this.state.query, page: 0, ignoreCurrentUser: true});
  }

  componentWillReceiveProps(nextProps) {
    if(!isEqual(this.props.loadUser, nextProps.loadUser) && nextProps.loadUser) {
      this.props.fetchUsers({query: this.state.query, page: 0, ignoreCurrentUser: false});
    }
  }

  _handleSearchQueryChange(e) {
		this.setState({
			query: e.target.value
		})
  }
  
  _handleSearch(event) {
    event.preventDefault();

    this.props.fetchUsers({query: this.state.query, page: 0, ignoreCurrentUser: false});
  }

  loadMoreUsers() {
    let totalPages = this.props.totalPages;
    let currentPage = this.props.currentPage;
    let nextPage = currentPage + 1;

    if (this.props.loading || nextPage > totalPages) {
      return;
    }

    this.props.fetchUsers({query: this.state.query, page: nextPage, ignoreCurrentUser: false});
  }

  _handleCreateClick() {
   
    var groupName = _.get(this.props,"name");
    var isAdministrator = _.get(this.props,"isAdministrator");
    var isCreateStream = _.get(this.props,"isCreateStream");
    var permissions = "";
    if(isAdministrator){
      permissions = "Administrator";
    }
    else if(isCreateStream){
      permissions = "Create Stream";
    }
   
    const users = _.get(this.props,"selectedUsers").map(user => ({
      [`${user.firstName} ${user.lastName}`]: user.email
    }));
    this.props.trackAdoptionMetricsForUserGroupCreatedevent(groupName,permissions,users)
    this.setState({
      query: ""
    })
    if (this.props.onFinish) {
      this.props.onFinish();
    }
  }
  
  _handleCancelClick() {
    if (this.props.userGroup) {
      this.props.fetchUserGroup(this.props.userGroup.id);
    } else {
      this.props.invalidateUserSelection();
    }

    this.setState({
      query: ""
    })
    if(this.props.onCancel) {
      this.props.onCancel();
    }
  }

  _toggleSelection(user) {
    var selected = this.props.isUserSelected(user);

    if (this.props.userGroup) {
      if (selected) {
        this.props.removeUserFromUserGroup(this.props.userGroup.id, user);
      } else {
        this.props.addUserToUserGroup(this.props.userGroup.id, user);
      }
    } else {
      if (selected) {
        this.props.deselectUser(user);
      } else {
        this.props.selectUser(user);
      }
    }
  }
      
  render() {
    return (
      <div>
        <Row className={styles.content}>
          <Col sm={12} md={12} className={cx(styles.column, styles.top)}>
            <h1 className={styles.pageTitle}>{this.localizedNewGroup.actions.add_users}</h1>
            <form className={styles.search} onSubmit={this._handleSearch}>
            <FormGroup className={styles.formGroup}>
              <InputGroup>
              <div className={styles.addon}>
                    <span className={cx(styles.icon, "paperflite-search")}></span>
                  </div>
                  <FormControl type="text"
                    placeholder={this.localizedCommons.search_placeholder}
                    value={this.state.query}
                    onChange={this._handleSearchQueryChange} />
                    <SearchButton className={styles.button} type="submit">{this.localizedCommonActions.search}</SearchButton>
              </InputGroup>
              </FormGroup>
            </form>
          </Col>

          <div className={styles.list}>
            <div className={styles.inner} ref={(element) => {
              this.scrollContainer = element;
            }}>

              {this._renderUsers()}

              {this.props.loading &&
                <div className={styles.loading}>{this.localizedCommonLoading.users} ...</div>
              }
            </div>
          </div>  
        </Row>

        <div className={styles.actionsAdd}>
          <Button
            onClick={this._handleCreateClick}
            text={this.localizedCommonActions.confirm}
            disabled={this.props.updating || this.props.creating}
            variant='primary'
          />
          <Button
            onClick={this._handleCancelClick}
            text={this.localizedCommonActions.cancel}
            variant='secondary'
          />
        </div>
      </div>
    );
  }

  _renderEmptyMessage() {
    return (
      <PlaceholderEmptyMessage
        title={this.localizedNewGroup.add_contact.empty_message.title}
        message={this.localizedNewGroup.add_contact.empty_message.sub_text}
        image={RolodexEmptyMessageSvgIcon}
        className={styles.emptyMessage}
        visible={true}
      />
    );
  }

  renderInitials(user){
    let initial = '';

    if(user.firstName){
      initial = user.firstName.charAt(0);
    }

    if(user.lastName){
      initial = initial + user.lastName.charAt(0);
    }

    return initial.toUpperCase();
  }

  renderName(user){
    return `${user.firstName || ''} ${user.lastName || ''}`
  }

  _renderUsers() {
		if (!this.props.users) {
			return null;
		}

		if (!this.props.loading && this.props.users.length == 0 && this.props.query != '') {
			return this._renderEmptyMessage();
		}

		let users = Array();

		this.props.users.forEach((user, index) => {
			var selected = this.props.isUserSelected(user);
      var disabled = this.props.isUserDisabled(user);
			users.push(
        <div
          key={user.id}
          className={cx(styles.userRow, { [styles.disabled]: disabled })}
          onClick={this._toggleSelection.bind(this, user)}
        >
          <div className={styles.left}>
            <div className={styles.iconContainer}>
              {!_.get(user, "icon.thumbnail") && (
                <div className={styles.contactAvatar}>
                  {" "}
                  {this.renderInitials(user)}{" "}
                </div>
              )}
              {_.get(user, "icon.thumbnail") && (
                <Image
                  className={styles.contactIcon}
                  src={_.get(user, "icon.thumbnail")}
                  circle
                />
              )}
            </div>
          </div>
          <div className={styles.body}>
            <div className={styles.bodyInner}>
              <div className={styles.contactName}>
                <Truncate lines={1}> {this.renderName(user)} </Truncate>
              </div>
              <div className={styles.contactTitle}>
                <Truncate lines={1}>
                  {" "}
                  {user.email || this.localizedCommons.no_details}{" "}
                </Truncate>
              </div>
            </div>
          </div>
          <div className={cx(styles.rightSelect, styles.selectButton)}>
            <i
              className={cx(
                selected
                  ? "paperflite-radio-button-selected"
                  : "paperflite-radio-button-unselected",
              )}
              aria-hidden="true"
            ></i>
          </div>
        </div>,
      );
		});
		
		return (
			<InfiniteScroll
				pageStart={0}
				initialLoad={false}
				hasMore={this.props.currentPage < this.props.totalPages}
				loadMore={this.loadMoreUsers}
				useWindow={false}
				threshold={200}
			>
				{users}
			</InfiniteScroll>
		);
	}
}

export default AddUsersView;    